<!-- 协议 -->
<template>
    <div v-if="componentsData.type == 11">
        <div class="bg-div" :style="bgStyle">
            <div class="txt" :style="txtStyle" @click="openInfo">
                <Icon
                    type="md-checkmark-circle"
                    :color="componentsData.content.unchecked_button_color"
                    size="16"
                    class="mr6"
                />
                请完整阅读《{{ componentsData.content.title }}》
            </div>
        </div>
        <!-- 弹窗协议 -->
        <Modal v-model="info_modal" width="375" class="info-modal">
            <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                {{ componentsData.content.title }}
            </div>
            <div v-html="componentsData.content.text"></div>
            <div class="btn-div" :style="btnStyle">同意</div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            info_modal: false,
        };
    },
    computed: {
        btnStyle() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.unviewed_button_color,
            };
        },
        txtStyle() {
            const content = this.componentsData.content;
            return {
                color: content.uncheck_text_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
    methods: {
        openInfo() {
            console.log("openInfo");
            this.info_modal = true;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.title-box {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
}
.btn-div {
    margin-top: 24px;
    padding: 6px;
    background: #d4d4d4;
    border-radius: 20px;
    color: #ffffff;
    text-align: center;
}
.txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mr6 {
    margin-right: 6px;
}
.info-modal ::v-deep .ivu-modal-footer {
    border-top: none !important;
    padding: 0px !important;
}
.info-modal ::v-deep .ivu-modal-close {
    display: none !important;
}
</style>
